<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div class="rubrics-container">
	<nz-tabs>
		<nz-tab nzTitle="Rubrics">
			@if (!showRubricForm) {
				<button (click)="toggleRubricForm()" nz-button nzType="primary">Add New</button>
				<br />
				<br />
			}
			@if (showRubricForm) {
				<app-rubric-form
					[rubric]="rubricService.selectedRubric$ | async"
					(onSubmit)="onRubricSubmit($event)"
				></app-rubric-form>
				<nz-divider></nz-divider>
			}
			<app-rubrics-table></app-rubrics-table>
		</nz-tab>
		<nz-tab nzTitle="Rubric Levels">
			<app-rubrics-table mode="select"></app-rubrics-table>
			@if (rubricService.selectedRubric$ | async) {
				@if (!showRubricLevelForm) {
					<button (click)="toggleRubricLevelForm()" nz-button nzType="primary">Add New</button>
					<br />
					<br />
				}
				<nz-divider></nz-divider>
				@if (showRubricLevelForm) {
					<app-rubric-level-form
						[rubric]="rubricService.selectedRubric$ | async"
						[rubricLevel]="rubricService.selectedRubricLevel$ | async"
						(onSubmit)="onRubricLevelSubmit($event)"
					></app-rubric-level-form>
					<nz-divider></nz-divider>
				}
				<app-rubric-levels-table [rubric]="rubricService.selectedRubric$ | async"></app-rubric-levels-table>
			}
		</nz-tab>
		<nz-tab nzTitle="Assessment">
			<app-rubrics-table mode="select"></app-rubrics-table>
			@if (rubricService.selectedRubric$ | async) {
				@if (!showEngineRubricSkillForm) {
					<button (click)="toggleEngineRubricSkillForm()" nz-button nzType="primary">
						Add New Assessment
					</button>
					<br />
					<br />
				}
				<nz-divider></nz-divider>
				@if (showEngineRubricSkillForm) {
					<app-engine-rubric-skill-form
						[rubric]="rubricService.selectedRubric$ | async"
						[engineRubricSkill]="engineService.selectedEngineRubricSkill$ | async"
						(onSubmit)="onEngineRubricSkillSubmit($event)"
					></app-engine-rubric-skill-form>
					<nz-divider></nz-divider>
				}
				<app-engine-rubric-skill-table
					[rubric]="rubricService.selectedRubric$ | async"
				></app-engine-rubric-skill-table>
			}
		</nz-tab>
	</nz-tabs>
</div>
